@if (!isOnMaintenanceMode()) {
<a href="#main-content" class="skip-to-content">Skip to main content</a>
<octo-header [isOctopusApp]="isOctopusApp" [showHeader]="showHeader" [isOrderTracking]="isOrderTracking"></octo-header>
@if (!showSideNav) {
<section id="main-content" tabindex="-1" class="content-wrapper main-container"
  [ngClass]="{ 'bonus-header': isBonus, 'no-top-padding': isOrderTracking }">
  <router-outlet></router-outlet>
</section>
} @else {
<section id="main-content" tabindex="-1" class="content-wrapper main-container">
  <octo-layout></octo-layout>
</section>
}
@if (isRouteLoading) {
<div class="loading-container">
  <div class="spinner-overlay">
    <mat-spinner diameter="30"></mat-spinner>
  </div>
  <span>Getting things ready for you...</span>
</div>
}
@if (!showSideNav) {
<octo-footer></octo-footer>
}
}

@if (isOnMaintenanceMode()) {
<octo-maintenance-mode></octo-maintenance-mode>
}